'use client';

interface FingerprintBanNoticeProps {
  onClose: () => void;
}

export default function FingerprintBanNotice({ onClose }: FingerprintBanNoticeProps) {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 animate-fadeIn">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-[#0f0f0f] border border-white/[0.08] rounded-xl p-8 max-w-md w-full shadow-2xl animate-scaleIn">
        {/* Ban Icon */}
        <div className="text-center mb-6">
          <div className="text-6xl mb-4">🚫</div>
          <h2 className="text-2xl font-bold text-white mb-2">Device Banned</h2>
          
          {/* Ban Type Badge */}
          <div className="inline-flex items-center justify-center">
            <span className="bg-red-500/20 text-red-400 border border-red-500/30 px-3 py-1 rounded-full text-sm font-semibold">
              Device Restriction
            </span>
          </div>
        </div>

        {/* Ban Details */}
        <div className="bg-white/[0.03] border border-white/[0.06] rounded-lg p-4 mb-6">
          <p className="text-sm text-white/90 leading-relaxed">
            This device has been flagged for abuse and cannot be used to access this platform.
          </p>
        </div>

        {/* Info Message */}
        <div className="bg-blue-500/10 border-l-4 border-blue-500 p-3 rounded text-sm text-blue-300 mb-6">
          <div className="flex items-start gap-2">
            <span className="text-lg flex-shrink-0">ℹ️</span>
            <div>
              <p className="mb-2">
                If you believe this is a mistake, please contact support with the following information:
              </p>
              <ul className="list-disc list-inside space-y-1 text-xs text-blue-300/80">
                <li>Your email address</li>
                <li>When you created your account</li>
                <li>Description of the issue</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Close Button */}
        <button
          onClick={onClose}
          className="w-full py-3 bg-white/[0.08] hover:bg-white/[0.12] text-white rounded-lg font-medium transition-colors duration-200"
        >
          Close
        </button>
      </div>
    </div>
  );
}

